import { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import SectionItemBox from './SectionItemBox.tsx';

interface SectionTitleWrapperType extends HTMLAttributes<HTMLDivElement> {
  title: string;
  dependencies: (string | null)[];
}

const SectionTitleWrapper = ({ title, children, className, dependencies, ...props }: SectionTitleWrapperType) => {
  const [t] = useTranslation();
  if (dependencies.every(item => item == null)) return;

  const content = children
    ? children
    : dependencies.map(item => (
        <SectionItemBox
          key={item}
          show={item || false}
        >
          {item}
        </SectionItemBox>
      ));
  return (
    <div>
      <h3
        className={`text-md text-lg font-bold ${className}`}
        {...props}
      >
        {t(title)}
      </h3>
      {content}
    </div>
  );
};

export default SectionTitleWrapper;
